import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusCardHeadline], [campus-card-headline], campus-card-headline',
})
export class CardHeadlineDirective {
  @HostBinding('class')
  defaultClasses = ['title-medium'];
}
